import { gql } from "@apollo/client";

export const GET_ESTADOS_RI = gql`
query estadosRI{
    estadosRI {
        idEstadosRI,
        descripcion
    }
  }
`;

export const adaptEstadoRI = (eRI) => ({
  id: eRI.idEstadosRI,
  displayName: eRI.descripcion
});

export const adaptEstadosRIArray = (estados) =>
structuredClone(estados?.estadosRI)?.
map((eRI) => adaptEstadoRI(eRI));